import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import config from '../../config';
import cookie from 'js-cookie';

import './LoginForm.css';

import { Button, Card, CardActions, CardContent, CardHeader, Typography, TextField } from '@mui/material';

const TRANSLATIONS_DEFAULT = {
	login_form_info: 'Log in with your account',
	login_form_ph_user: 'Username',
	login_form_ph_pass: 'Password',
	login_form_error: 'Something went wrong while trying to log in: ',
	login_form_action: 'Log in',
	login_form_compat_message: 'Warning: this browser does not meet requirements for this app to run properly. We recommend using Google Chrome on Android devices or desktop computers.',
};

function translate(t, key) {
	return t
		? t[key] || TRANSLATIONS_DEFAULT[key]
		: TRANSLATIONS_DEFAULT[key];
}

function LoginForm(props) {
	const { t } = useSelector(redux => redux.store);
	const [error, setError] = useState();
	const [message, setMessage] = useState();

	useEffect(() => {
		checkBackgroundSyncSupport();
	});

	function checkBackgroundSyncSupport() {
		if (!('SyncManager' in window)) {
			setMessage(translate(t, 'login_form_compat_message'));
		}
	}

	function handleSubmit(event) {
		event.preventDefault();

		fetch(event.target.action, {
			method: event.target.method,
			credentials: 'include',
			body: new FormData(event.target),
		})
			.then(response => response.json())
			.then(json => {
				if (json.status >= 200 && json.status < 300) {
					cookie.set('auth', true, { expires: 365, sameSite: 'Lax' });
					// @refactor: these ↓ don’t need to be in cookie, can much more easily be stored in localstorage
					cookie.set('username', json.data.username, { expires: 365, sameSite: 'Strict' });
					cookie.set('name', json.data.name, { expires: 365, sameSite: 'Strict' });
					cookie.set('locale', json.data.locale, { expires: 365, sameSite: 'Strict' });
					props.updateAppState(
						{ is_auth: true },
						() => window.location.href = '/',
					);
				} else {
					setError(json.message);
				}
			})
			.catch(err => {
				setError(translate(t, 'login_form_error') + err.toString());
			});
	}

	return (
		<Card className="login-form card-medium" classes={{ root: 'login-form' }}>
			<div className="login-form-left">
				<img className="login-form-logo" src={`${ config.api.remoteApi }${ config.app_logo }`} alt={`${config.app_long_brand_name} Logo`} />
			</div>
			<div className="login-form-right">
				<CardHeader
					title={<Typography component="span" variant="h5">{config.app_name}</Typography>}
					subheader={translate(t, 'login_form_info')}
				/>
				<form
					method="post"
					action={`${config.api.url}/login`}
					onSubmit={ handleSubmit }>
					<CardContent>
						<TextField
							variant="standard"
							fullWidth={true}
							placeholder={translate(t, 'login_form_ph_user')}
							name="username"
							InputProps={{ classes: { input: 'input' } }} />
						<br />
						<TextField
							variant="standard"
							fullWidth={true}
							placeholder={translate(t, 'login_form_ph_pass')}
							name="password"
							type="password"
							helperText={ error }
							FormHelperTextProps={{ error: !!error }}
							InputProps={{ classes: { input: 'input' } }} />
					</CardContent>
					<CardActions
						classes={{root: 'card-actions'}}
						children={
							<Button variant="contained" type="submit" color="primary" classes={{ root: 'button' }}>
								{translate(t, 'login_form_action')}
							</Button>
						}
					/>
				</form>
				{ message &&
					<p>{ message }</p>
				}
			</div>
		</Card>
	);
}

export default LoginForm;
